import React, { useState, useEffect } from "react";
import { Button, Modal, Checkbox, Input } from 'semantic-ui-react'
import { useTextResources ,useMessageResources} from "../../language";
import PropTypes from 'prop-types'
import GridPanel from '../../components/GridPanel'
import moment from 'moment'
import { timeFormat, dateFormat } from '../../components/shared/constants';
import NumericInput from "../shared/NumericInput";
import { HotelAddonDropDown } from '../shared/HotelAddonDropDown'
import { Currencies } from "../shared/currencies";
import { GetProducts, SaveReservation, GetReservation, GetHotelAddons } from "../../api/services/pms";
import { DatePicker } from "../shared/DatePicker";
import "./style.less"
import { onSuccess, onWarning } from "../shared/messages";
import { useLoader } from '../shared/utils'

const ExtraAddons = ({ reservation, ...rest }) => {
    const [isOpen, setIsOpen] = useState(rest.open)
    const text = useTextResources()
    const messages = useMessageResources()
    const [data, setData] = useState([])
    const [dataForDeletion, setDataForDeletion] = useState([])
    const [products, setProducts] = useState([])
    const loader = useLoader();
    const [reservationFromDB, setReservation] = useState([])
    const [selected, setSelected] = useState([]);
    const [hotelAddonData, setHotelAddonData] = useState([])

    useEffect(() => {
        (async () => {
            if (rest.open === true && reservation?.Id) {
                loader(true);
                const [dailyAddons, product, hotelAddon] = await Promise.all([
                    GetReservation({
                        Ids: [reservation.Id],
                        IncludeAddonsWithChainAndDiningRooms: true,
                        IncludeReservationDailyAccommodations: true,
                        IncludeTotalAmounts: true,
                        IncludeDayAmounts: true,
                        IncludeHotelAddons: true
                    }),

                    GetProducts({
                        HotelID: reservation.HotelId,
                        StartDate: moment(reservation.CheckInDate).startOf('day').toISOString(),
                        EndDate: moment(reservation.CheckOutDate).startOf('day').toISOString()
                    }),
                    GetHotelAddons({
                        HotelID: reservation?.HotelId,
                        StartDate: moment(reservation?.CheckInDate).startOf('day').toISOString(),
                        EndDate: moment(reservation?.CheckOutDate).startOf('day').toISOString(),
                        IncludeFilteredByRate: true,
                        IncludeAddonChain: true
                    })
                ])
                setData(dailyAddons.ReservationDailyAddons)
                setProducts(product)
                setReservation(dailyAddons)
                setHotelAddonData(hotelAddon)
                loader(false);
            }
        })()
    }, [rest.open]);

    const closeHandler = () => {
        rest?.onClose?.()
        setData([])
        setIsOpen(false)
    }
    const manualFormatter = ({ row }) => {
        if (row.RoomAmount === null && (
            row.ChildAmount != row.OriginalChildAmount ||
            row.AdultAmount != row.OriginalAdultAmount ||
            row.ChildQuantity != reservation.Children ||
            row.AdultQuantity != reservation.Adults) ||
            (row.RoomAmount != row.OriginalRoomAmount ||
                row.Quantity != 1)
        ) {
            return <Checkbox checked={true} />
        }
        return <Checkbox checked={false} />

    }
    const currencyFormatter = ({ value }) => {
        return Currencies[value]?.symbol || ''
    }
    const dateFormatter = ({ value }) => {
        return value && moment(value).format(dateFormat) || ''
    }
    const timeFormatter = ({ value }) => {
        return value && moment(value).format(timeFormat) || ""
    }
    const productFormatter = ({ value }) => {
        return products && products.find(r => r.Id === value)?.ProductName || '';
    }
    const totalAmountFormatter = ({ row }) => {
        if (row.RoomAmount === null)
            return ((row.AdultQuantity || 0) * (row.AdultAmount || 0) + (row.ChildQuantity || 0) * (row.ChildAmount || 0)).toFixed(2);
        else {
            var roomAmountQuinty = !row.Quantity ? 1 : row.Quantity;
            return ((roomAmountQuinty || 0) * (row.RoomAmount || 0)).toFixed(2);
        }
    }
    const addNewDailyAddon = () => {
        setData([...data,
        {
            Id: `New-${crypto.randomUUID()}`,
            Date: reservation.CheckInDate,
            ProductID: null
        }])
    }
    const deleteAddon = () => {
        let updated = [...data]
        if (selected.length) {
            const selectedIdsForDeletion = selected.filter((index) => updated[index].ProductID === null &&
                updated[index].FolioTransactionID === null)
                .map((index) => updated[index].Id);

            const deletedRows = updated
                .filter((item) => selectedIdsForDeletion.includes(item.Id) &&
                    typeof item.Id != 'string')
                .map((item) => ({ ...item, IsDeleted: true }));

            updated = updated.filter(
                (item) => !selectedIdsForDeletion.includes(item.Id));

            setSelected([])
            setDataForDeletion([...dataForDeletion, ...deletedRows])
        }
        setData(updated)
    }
    const save = () => {
        (async () => {
            try {
                loader(true);
                reservationFromDB.ReservationDailyAddons = [...data, ...dataForDeletion]
                await SaveReservation({ ...reservationFromDB, IsPrimaryGroupReservation: true })
                rest?.reservationDailyAddonsExist?.(data?.length > 0)
                setDataForDeletion([])
                onSuccess()
                closeHandler()
            }
            catch (error) {
                onWarning(error)
            }
            finally {
                loader(false);
            }
        })()
    }
    const changeRow = (property, id, newValue) => {
        var item = data.find(x => x.Id === id)
        if(newValue === 0 &&
           (property === 'AdultQuantity' && item.ChildQuantity === 0 )||
           (property === 'ChildQuantity' && item.AdultQuantity === 0))
        {
            return onWarning(messages('QuantityIsRequired'))
        }
        setData((data) =>
            data.map((item) =>
                item.Id !== id
                    ? item
                    : {
                        ...item,
                        [property]:
                            typeof newValue == 'number' ? parseInt(newValue) : newValue,
                        //Update prices
                        RoomAmountBeforeTax: property === 'RoomAmount' ? newValue : item.RoomAmountBeforeTax,
                        RoomAmountAfterTax: property === 'RoomAmount' ? newValue : item.RoomAmountAfterTax,
                        AdultAmountBeforeTax: property === 'AdultAmount' ? newValue : item.AdultAmountBeforeTax,
                        AdultAmountAfterTax: property === 'AdultAmount' ? newValue : item.AdultAmountAfterTax,
                        ChildAmountBeforeTax: property === 'ChildAmount' ? newValue : item.ChildAmountBeforeTax,
                        ChildAmountAfterTax: property === 'ChildAmount' ? newValue : item.ChildAmountAfterTax,
                        //Update ConsumptionDate
                        ConsumptionDate: property === 'Date' ? newValue : item.ConsumptionDate
                    }
            )
        );
    };

    const createEditableFormatter = (property) => {
        // eslint-disable-next-line react/display-name, react/prop-types
        return ({ value, row }) => {
            return (
                <NumericInput
                    disabled={row.ProductID || row.FolioTransactionID || (value != 0 && !value)}
                    value={value}
                    style={{ width: '100%' }}
                    onChangeComplete={(value) =>
                        changeRow(property, row.Id, value)
                    }
                    buttonPlacement='none'
                    min={0}
                    digits={0}
                />
            );
        };
    };
    const createDateFormatter = ({ value, row }) => {
        return (
            <div className='extra-addon-dropdown' style={{ width: '100%' }}>
                <DatePicker
                    disabled={row.ProductID || row.FolioTransactionID}
                    value={moment(value || reservation.CheckInDate).toDate()}
                    className='extra-addon-dropdown'
                    onChange={(value) =>
                        changeRow("Date", row.Id, value || reservation.CheckInDate)
                    }
                /></div>
        );
    };
    const applyAddonPrices = (value, row) => {
        const currentAddon = hotelAddonData.find(x => x.Id == value)
        setData((data) =>
            data.map((item) =>
                item.Id !== row.Id
                    ? item
                    : {
                        ...item,
                        HotelAddonId: value,
                        ChildAmount: currentAddon.ChildAmount,
                        ChildAmountBeforeTax: currentAddon.ChildAmountBeforeTax,
                        ChildAmountAfterTax: currentAddon.ChildAmountAfterTax,
                        OriginalChildAmount: currentAddon.ChildAmount,
                        AdultAmount: currentAddon.AdultAmount,
                        AdultAmountBeforeTax: currentAddon.AdultAmountBeforeTax,
                        AdultAmountAfterTax: currentAddon.AdultAmountAfterTax,
                        OriginalAdultAmount: currentAddon.AdultAmount,
                        RoomAmount: currentAddon.RoomAmount,
                        RoomAmountBeforeTax: currentAddon.RoomAmountBeforeTax,
                        RoomAmountAfterTax: currentAddon.RoomAmountAfterTax,
                        OriginalRoomAmount: currentAddon.RoomAmount,
                        AdultQuantity: currentAddon.AdultAmount ? reservation.Adults > 0 ?  reservation.Adults : 1 : null,
                        ChildQuantity: currentAddon.ChildAmount ? reservation.Children > 0 ?  reservation.Children : 1: null,
                        Quantity: currentAddon.RoomAmount ? reservation.Quantity : null,
                        CurrencyId: currentAddon.CurrencyID,
                        IsActive: true,
                        ConsumptionDate: row.Date
                    }
            )
        );
    }

    const createAddonFormatter = ({ value, row }) => {
        return (
            row.ProductID || row.FolioTransactionID ?
                <Input
                    disabled={true}
                    style={{ width: '100%' }}
                    value={row.HotelAddon?.ChainAddon?.Name}
                    buttonPlacement='none'
                /> :
                <div className='extra-addon-dropdown' style={{ marginLeft: '-0px' }}>
                    <HotelAddonDropDown
                        value={value}
                        className='extra-addon-dropdown'
                        data={hotelAddonData}
                        onChange={(item) =>
                            applyAddonPrices(item, row)
                        }
                    /></div>
        );
    };

    const customPropsCallback = (property) => {
        return (props) => {
            const newProps = { ...props };
            if (!newProps.value) {
                newProps.value = 0;
            }

            if (!newProps.row[property]) {
                newProps.row = { ...newProps.row, [property]: 0 };
            }

            return newProps;
        };
    };

    const gridOptions = {
        columns: [
            {
                name: 'Date',
                title: text('Date'),
                formatter: createDateFormatter,
                customProps: customPropsCallback('Date')
            },
            {
                name: 'HotelAddonId',
                title: text('AddOn'),
                formatter: createAddonFormatter,
                customProps: customPropsCallback('HotelAddonId')
            },
            {
                name: 'RoomAmount',
                title: text('RoomAmount'),
                formatter: createEditableFormatter('RoomAmount'),
                customProps: customPropsCallback('RoomAmount')
            },
            {
                name: 'Quantity',
                title: text('Quantity'),
                formatter: createEditableFormatter('Quantity'),
                customProps: customPropsCallback('Quantity')
            },
            {
                name: 'AdultQuantity',
                title: text('Adult'),
                formatter: createEditableFormatter('AdultQuantity'),
                customProps: customPropsCallback('AdultQuantity')
            },
            {
                name: 'ChildQuantity',
                title: text('Child'),
                formatter: createEditableFormatter('ChildQuantity'),
                customProps: customPropsCallback('ChildQuantity')
            },
            {
                name: 'AdultAmount',
                title: text('AdultAmount'),
                formatter: createEditableFormatter('AdultAmount'),
                customProps: customPropsCallback('AdultAmount')
            },
            {
                name: 'ChildAmount',
                title: text('ChildAmount'),
                formatter: createEditableFormatter('ChildAmount'),
                customProps: customPropsCallback('ChildAmount')
            },
            { name: 'TotalAmount', title: text('TotalAmount'), formatter: totalAmountFormatter },
            { name: 'CurrencyId', title: text('Currency'), formatter: currencyFormatter },
            { name: 'Manual', title: text('Manual'), formatter: manualFormatter },
            { name: 'ProductId', title: text('Product'), formatter: productFormatter },
            { name: 'UpdateDate', title: text('UpdateDate'), formatter: dateFormatter },
            { name: 'DiningRoomId', title: text('DiningRoom') },
            { name: 'DiningRoomStartHour', title: text('StartHour'), formatter: timeFormatter },
            { name: 'DiningRoomEndHour', title: text('EndHour'), formatter: timeFormatter },
        ],
        paging: true,
        selectable: true,
        selectableCallback: row => {
            return row.ProductID === null && row.FolioTransactionID === null
        },
    };

    return <Modal open={isOpen} {...rest} size="large">
        <Modal.Header>{text("Addons")}</Modal.Header>
        <Modal.Content>
            <Button positive onClick={addNewDailyAddon}>{text('AddNew')}</Button>
            <Button negative onClick={deleteAddon}>{text('Delete')}</Button>
            <GridPanel
                className="extra-addons-grid"                
                data={data}
                options={gridOptions}
                onSelected={setSelected}
            />
        </Modal.Content>
        <Modal.Description>
            <p style={{fontWeight: 'bold', paddingBottom: '20px', paddingLeft: '20px'}}>{text('TotalPrice')}{' '}{reservationFromDB?.TotalAmountAddons?.toFixed(2)}</p>
        </Modal.Description>
        <Modal.Actions>
            <Button negative size="small" onClick={closeHandler}>{text("Cancel")}</Button>
            <Button positive size="small" onClick={save}>{text("Save")}</Button>
        </Modal.Actions>
    </Modal >
}
ExtraAddons.propTypes = {
    reservation: PropTypes.object,
    open: PropTypes.object,
    row: PropTypes.object,
    onCancelChanges: PropTypes.func,
    setTemplates: PropTypes.func,
    extendedProps: PropTypes.object,
}
export default ExtraAddons;
